/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * An enumeration.
 * @export
 */
export const RunTaskActionWhenDoneEnum = {
    Shutdown: 'shutdown',
    Wait: 'wait',
    NextOrWait: 'next_or_wait',
    NextOrShutdown: 'next_or_shutdown'
} as const;
export type RunTaskActionWhenDoneEnum = typeof RunTaskActionWhenDoneEnum[keyof typeof RunTaskActionWhenDoneEnum];


export function RunTaskActionWhenDoneEnumFromJSON(json: any): RunTaskActionWhenDoneEnum {
    return RunTaskActionWhenDoneEnumFromJSONTyped(json, false);
}

export function RunTaskActionWhenDoneEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunTaskActionWhenDoneEnum {
    return json as RunTaskActionWhenDoneEnum;
}

export function RunTaskActionWhenDoneEnumToJSON(value?: RunTaskActionWhenDoneEnum | null): any {
    return value as any;
}

